var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mtxx-h5"},[_c('img',{staticClass:"mt-bg",attrs:{"src":"https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/mtxxh5-bg","alt":""}}),_c('div',{staticClass:"mt-btn user-btn",on:{"click":_vm.handleClick}},[_vm._v("立即领取")])])}
var staticRenderFns = []

export { render, staticRenderFns }